import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from '@mafc/trolly';

import EnableSubstitutionLayout from './EnableSubstitutionLayout';

const displayPropLG = ['none', '', 'block'];
const EnableSubstitutionLoader = () => (
  <Box display={displayPropLG}>
    <EnableSubstitutionLayout>
      <ContentLoader
        className="skeleton-loader"
        height={24}
        width={800}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="0" rx="2" ry="2" width="24" height="24" />
        <rect x="46" y="5" rx="5" ry="5" width="160" height="12" />
      </ContentLoader>
    </EnableSubstitutionLayout>
  </Box>
);

export default EnableSubstitutionLoader;
